
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

export const initCapacitor = async () => {
  try {
    const isNative = Capacitor.isNativePlatform();
    const platform = Capacitor.getPlatform();
    
    console.log('Platform detected:', platform);
    console.log('Is native app:', isNative);
    
    if (isNative) {
      // Configure status bar
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: '#FF8C00' });
      
      // Hide splash screen after app is ready
      await SplashScreen.hide();
    }
    
    return {
      isNative,
      platform
    };
  } catch (error) {
    console.error("Error initializing Capacitor:", error);
    return {
      isNative: false,
      platform: 'web'
    };
  }
};

export const hideSplashScreen = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      await SplashScreen.hide();
    }
  } catch (error) {
    console.error("Error hiding splash screen:", error);
  }
};
